import { render } from "./testExam.vue?vue&type=template&id=273aa268&scoped=true"
import script from "./testExam.vue?vue&type=script&lang=js"
export * from "./testExam.vue?vue&type=script&lang=js"

import "./testExam.vue?vue&type=style&index=0&id=273aa268&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273aa268"]])

export default __exports__